import { Box, Circle, Flex, Heading, Img, Text, Wrap } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import chat_Icon from "Assets/chat_icon.png";
import { ComapanyJobs } from "./ComapanyJobs";
import poly from "Assets/download.png";
import award from "Assets/award.svg";
import { getCompanyDetailsAndJobs, getUserById } from "services/api";
import { Skills } from "contants/contants";
import { useNavigate } from "react-router-dom";
import { useWindow } from "hooks/useWindow";
import arrow from "Assets/arrowLeft.svg";

export const StudentProfileCard = ({ id, mobileView, setMobileView }) => {
  const [studentData, setStudentData] = useState(null);
  const navigate = useNavigate();
  const windowSize = useWindow();

  useEffect(() => {
    if (id) {
      const fetchUser = async () => {
        const { data } = await getUserById(id);
        setStudentData(data?.data);
      };
      fetchUser();
    }
  }, [id]);

  const downloadResume = (link) => {
    const a = document.createElement("a");
    a.href = link;
    a.download = "resume";
    a.click();
    document.body.appendChild(a);
    a.style = "display: none";
    document.body.removeChild(a);
  };

  return (
    <div>
      <Flex
        className={
          !mobileView?.chatBox && !mobileView?.profile ? "mobile-d-none" : ""
        }
        flexDir={"column"}
        justify={"center"}
        w={mobileView?.profile ? "100%" : "25vw"}
        height={"100%"}
        borderLeft={
          !mobileView?.chatList && windowSize < 500
            ? "none"
            : "1px solid #E4E4E4"
        }
        m={"auto"}
      >
        {/* Title */}
        <Flex
          align={"center"}
          //   my={4}
          px={6}
          gap={2}
          height={"87px"}
          borderBottom="1px solid #E4E4E4"
        >
          {windowSize < 500 && (
            <Img
              src={arrow}
              width={30}
              onClick={() => {
                setMobileView((prev) => ({ ...prev, profile: false }));
              }}
            />
          )}

          <Text
            fontSize={24}
            fontFamily={"Epilogue"}
            color={"#544D5E"}
            fontWeight={700}
            mt={1}
          >
            Profile
          </Text>
        </Flex>

        {/* Tabs */}

        {!studentData && (
          <Flex height={"90vh"} padding={"10px"}>
            <Heading variant={"h6"} padding={"10px"} size={"md"}>
              Select a student to view profile
            </Heading>
          </Flex>
        )}
        {/* chatlist */}
        {studentData && (
          <Flex
            flexDir={"column"}
            h={"90vh"}
            css={{
              "::-webkit-scrollbar": {
                width: 0,
                height: 0,
              },
            }}
            overflow={"auto"}
            gap={2}
            px={4}
          >
            <Box>
              {/* <Flex>
                <Heading
                  paddingTop={2}
                  size={"md"}
                  color={"#4E4E4E"}
                  fontWeight={"500"}
                  fontFamily={"Roboto"}
                  fontSize={"18px"}
                >
                  Posted By:
                </Heading>
              </Flex> */}
              <Flex
                align="center"
                gap={2}
                my={5}
                padding={2}
                borderRadius={15}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                flexDirection={"column"}
              >
                <Flex
                  border={"1px solid #DDDDDD"}
                  className="radius-50"
                  padding={1}
                >
                  <img
                    src={studentData?.profilePhoto}
                    alt="company"
                    className="radius-50"
                    style={{ width: "110px", height: "110px" }}
                  />
                </Flex>
                <Flex className="radius-50" padding={1}>
                  <Heading size={"md"}>{studentData?.name}</Heading>
                </Flex>
                <Flex
                  border={"1px solid #DDDDDD"}
                  borderRadius={15}
                  padding={"5px 15px"}
                  _hover={{
                    cursor: "pointer",
                    backgroundColor: "#F2F2F2",
                  }}
                  onClick={() => {
                    navigate(
                      `/hiring/recruiter/studentprofile/${studentData?._id}`
                    );
                  }}
                >
                  <Heading size="md">View Full Profile</Heading>
                </Flex>
              </Flex>
              <Flex flexWrap={"wrap"}>
                {studentData?.badges?.map((badge) => (
                  <Flex
                    border={"1px solid #DDDDDD"}
                    borderRadius={15}
                    padding={"5px 15px"}
                    mb={2}
                    mx={1}
                  >
                    <Img src={award} mr={1} />
                    <Text>{Skills[badge]}</Text>
                  </Flex>
                ))}
              </Flex>
              <Flex flexDirection={"column"}>
                <Flex borderRadius={15} mb={2}>
                  <Heading size="sm">Bio</Heading>
                  <br />
                </Flex>
              </Flex>
              <Flex>
                <Text textAlign={"left"} mb={2}>
                  {studentData?.bio}
                </Text>
              </Flex>
              <Flex flexDirection={"column"}>
                <Flex borderRadius={15} mb={2}>
                  <Heading size="sm">Work</Heading>
                  <br />
                </Flex>
              </Flex>
              <Flex
                textAlign={"center"}
                display={studentData.resume?"flex":"none"}
                justifyContent={"center"}
                alignItems={"center"}
                height={"45px"}
                mb={4}
                _hover={{
                  cursor: "pointer",
                  backgroundColor: "#F2F2F2",
                  borderRadius: 15,
                }}
                onClick={() => {
                  downloadResume(studentData?.resume);
                }}
              >
                <Img src={poly} mr={3} />
                <Heading size={"md"}>Download Resume</Heading>
              </Flex>
              <Flex justifyContent={"space-between"} my="2">
                <Img
                  width={"165px"}
                  height={"142px"}
                  onError={(e) =>
                    (e.target.src = "https://via.placeholder.com/150")
                  }
                  src={
                    (studentData?.uploaded &&
                      studentData?.uploaded[0]?.url[0]) ||
                    "https://via.placeholder.com/150"
                  }
                  borderRadius={15}
                />
                <Img
                  width={"165px"}
                  height={"142px"}
                  onError={(e) =>
                    (e.target.src = "https://via.placeholder.com/150")
                  }
                  src={
                    (studentData?.uploaded &&
                      studentData?.uploaded[1]?.url[0]) ||
                    "https://via.placeholder.com/150"
                  }
                  borderRadius={15}
                />
              </Flex>
            </Box>
          </Flex>
        )}
      </Flex>
    </div>
  );
};
